
import React, {useState, useEffect} from 'react';
import './index.less';

const StepThird = () => {
  const [timeNum, setTimeNum] = useState(5);

  useEffect(()=>{
    let seconds = timeNum;
    const sendtimer = setInterval(()=>{
        if (seconds > 1) {
            seconds = seconds - 1;
            setTimeNum(seconds);
            if (window.location.href.indexOf('closure_info') === -1) {
              clearInterval(sendtimer);
            }
        } else {
            window.location.href = 'http://we.gyyx.cn';
            clearInterval(sendtimer);
            return false;
        }
    },1000);

},[]);

  return (
    <div className='wgClosureThird'>
      <div className="succ_acc">
        <span className="succ_title">封停成功！</span>
        <p className="succ_timer">
          {timeNum}秒后跳转至首页.......
          <a href="http://we.gyyx.cn">立即跳转</a>
        </p>
      </div>
    </div>
  );
};

export default StepThird;
